import { render, staticRenderFns } from "./activityBaseModal.vue?vue&type=template&id=19ca6730&scoped=true"
import script from "./activityBaseModal.vue?vue&type=script&lang=js"
export * from "./activityBaseModal.vue?vue&type=script&lang=js"
import style0 from "./activityBaseModal.vue?vue&type=style&index=0&id=19ca6730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ca6730",
  null
  
)

export default component.exports